import ScreenerQuestionSchema from '@ax2/common/model/schemas/ScreenerQuestionSchema';
import AnswerData from '@ax2/common/model/answers-data/AnswerData';
import QuestionType from '@ax2/common/model/QuestionType';
import OptionsGridAnswerData from '@ax2/common/model/answers-data/OptionsGridAnswerData';
import _ from 'lodash';
import OptionsListAnswerData from '@ax2/common/model/answers-data/OptionsListAnswerData';
import SingleOptionAnswerData from '@ax2/common/model/answers-data/SingleOptionAnswerData';
import TextsListAnswerData from '@ax2/common/model/answers-data/TextsListAnswerData';

export const isTerminated = (
  schema: ScreenerQuestionSchema,
  answer: AnswerData
) => {
  switch (schema.questionType) {
    case QuestionType.RatingList:
    case QuestionType.CheckboxGrid:
    case QuestionType.RadioButtonGrid:
      return isGridColumnOptionsTerminated(
        schema,
        answer as OptionsGridAnswerData
      );
    case QuestionType.CheckboxList:
      return isListOptionsTerminated(schema, answer as OptionsListAnswerData);
    case QuestionType.DropdownMenu:
    case QuestionType.RadioButtonList:
      return isSingleOptionTerminated(schema, answer as SingleOptionAnswerData);
    case QuestionType.ContinuousSumList:
      return isSumTerminated(schema, answer as TextsListAnswerData);
    default:
      return false;
  }
};

const isGridColumnOptionsTerminated = (
  schema: ScreenerQuestionSchema,
  answers: OptionsGridAnswerData
): boolean => {
  if (schema.screenoutStrategy === 'Match') {
    const answerIds = _.map(answers.selected, s => s.columnId);
    return _.intersection(answerIds, schema.screenout).length > 0;
  } else if (schema.screenoutStrategy === 'NotMatch') {
    const answerIds = _.map(answers.selected, s => s.columnId);
    return _.findIndex(answerIds, schema.screenout[0]) === -1;
  }
  return false;
};

const isListOptionsTerminated = (
  schema: ScreenerQuestionSchema,
  answers: OptionsListAnswerData
): boolean => {
  if (schema.screenoutStrategy === 'Match') {
    const answerIds = _.map(answers.selected, s => s.id);
    return _.intersection(answerIds, schema.screenout).length > 0;
  } else if (schema.screenoutStrategy === 'NotMatch') {
    const answerIds = _.map(answers.selected, s => s.id);
    return _.findIndex(answerIds, id => id === schema.screenout[0]) === -1;
  }
  return false;
};

const isSingleOptionTerminated = (
  schema: ScreenerQuestionSchema,
  answer: SingleOptionAnswerData
): boolean => {
  if (schema.screenoutStrategy === 'Match') {
    return (
      !!answer.selectedId &&
      _.findIndex(schema.screenout, s => s === answer.selectedId) !== -1
    );
  } else if (schema.screenoutStrategy === 'NotMatch') {
    return (
      !!answer.selectedId &&
      _.findIndex(schema.screenout, s => s === answer.selectedId) === -1
    );
  }
  return false;
};

const isSumTerminated = (
  schema: ScreenerQuestionSchema,
  answers: TextsListAnswerData
): boolean => {
  const answerText = _.find(
    answers.selected,
    s => s.id === schema.screenout[0]
  );
  const value =
    answerText && answerText.text ? parseInt(answerText.text) : null;

  return (
    schema.screenoutValue !== undefined &&
    value !== null &&
    !isNaN(value) &&
    value < schema.screenoutValue
  );
};
